import { Button, Modal, Typography } from "@povio/ui";
import Image from "next/image";

import { PlayCircleIcon } from "@/assets/icons/general/PlayCircleIcon";
import LiveshowModalImage from "@/assets/images/liveshow-modal-image.png";

interface LiveshowNotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onWatchNow: () => void;
}

export const LiveshowNotificationModal = ({ isOpen, onClose, onWatchNow }: LiveshowNotificationModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      aria-label="modal"
      modalClassName="max-w-[480px] w-full"
      showCloseIcon
      closeIconClassName="right-4 top-2"
    >
      <div className="flex w-full flex-col gap-2">
        <Typography
          size="title-5"
          variant="prominent-1"
          className="pb-4 text-desktop-title-5!"
          data-testid="liveshow-notification-title"
        >
          One Lucky Dog is LIVE!
        </Typography>

        <div className="relative w-full">
          <Image
            src={LiveshowModalImage}
            width={480}
            height={480}
            alt="Liveshow Modal Image"
            className="h-full w-full object-contain"
          />
        </div>

        <div className="py-2">
          <Typography
            size="body-4"
            className="text-text-default-2"
          >
            Tune in to hear real conversations about careers, growth, and what actually moves the needle.
          </Typography>
        </div>

        <div className="pt-6">
          <Button
            color="secondary"
            size="s"
            className="w-full"
            icon={PlayCircleIcon}
            onPress={onWatchNow}
          >
            Watch Live
          </Button>
        </div>
      </div>
    </Modal>
  );
};
